import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Basketmenuitems from './components/cart/basket-menu-items/Basketmenuitems';
import Storelocator from './components/storelocator/Storelocator';
import Cart from './components/cart/Cart';
import Minibasket from './components/cart/mini-basket/Minibasket';
import Basket from './components/cart/basket/Basket';
import Checkout from './components/cart/checkout/Checkout';
// import Mattresspage from './components/cart/mattress-page/Mattresspage';

const ecom = true;

const screenSize = window.document.documentElement.clientWidth;
const XscreenSize = window.document.documentElement.screenSize;


//console.log(`screensize: ${XscreenSize} screenwidth: ${screenSize}`);
//console.log(`path name: ${window.location.pathname}`)
if (window.location.pathname === '/en/find-a-retailer/' || window.location.pathname === '/fr/find-a-retailer/') {
  //console.log(`Google Maps loading`)
  ReactDOM.render(<App />, document.getElementById('dummyReact'));
  ReactDOM.render(<Storelocator />, document.getElementById('geomap'));
  // ReactDOM.render(<Cartbasket/>, document.getElementById('cocoon-basket'));

    ReactDOM.render(
      <Basketmenuitems ref={ (basketmenuitems) => { window.basketmenuitems = basketmenuitems }} />,
      document.getElementById('basket-items')
    );
}else if (window.location.pathname === '/fr/checkout/' || window.location.pathname === '/en/checkout/') {
  console.log(`checkout page`)
  ReactDOM.render(<App />, document.getElementById('dummyReact'));
}else if (window.location.pathname === '/en/store/basket/' || window.location.pathname === '/fr/store/basket/') {
  ReactDOM.render(<Basket ref={ (Basket) => { window.Basket = Basket }} />, document.getElementById('basket-app'));
  ReactDOM.render(
    <Basketmenuitems ref={ (basketmenuitems) => { window.basketmenuitems = basketmenuitems }} />,
    document.getElementById('basket-items')
  );
  ReactDOM.render(<Minibasket ref={ (Cartbasket) => { window.Cartbasket = Cartbasket }} />, document.getElementById('cocoon-basket'));
}else if (window.location.pathname === '/en/store/checkout/' || window.location.pathname === '/fr/store/checkout/') {

  ReactDOM.render(<Checkout ref={ (checkout) => { window.checkout = checkout }} />, document.getElementById('checkout-app'))

}
else if (window.location.pathname === '/en/mattress/essential/purchase/' || window.location.pathname === '/fr/mattress/essential/purchase/' ||
window.location.pathname === '/en/mattress/classic/purchase/' || window.location.pathname === '/fr/mattress/classic/purchase/'
|| window.location.pathname === '/en/pillows/premium-pillow/' || window.location.pathname === '/fr/pillows/premium-pillow/'
|| window.location.pathname === '/en/pillows/essentials-pillow/' || window.location.pathname === '/fr/pillows/essentials-pillow/'
|| window.location.pathname === '/en/pillows/performance-pillow/' || window.location.pathname === '/fr/pillows/performance-pillow/') {
  ReactDOM.render(<Cart ref={ (maincart) => { window.maincart = maincart }} />, document.getElementById('configurator'))
  ReactDOM.render(
    <Basketmenuitems ref={ (basketmenuitems) => { window.basketmenuitems = basketmenuitems }} />,
    document.getElementById('basket-items')
  );
  ReactDOM.render(<Minibasket ref={ (Cartbasket) => { window.Cartbasket = Cartbasket }} />, document.getElementById('cocoon-basket'));
  if (window.location.pathname === '/en/pillows/premium-pillow/' || window.location.pathname === '/fr/pillows/premium-pillow/'
  || window.location.pathname === '/en/pillows/essentials-pillow/' || window.location.pathname === '/fr/pillows/essentials-pillow/'
  || window.location.pathname === '/en/pillows/performance-pillow/' || window.location.pathname === '/fr/pillows/performance-pillow/'
  || window.location.pathname === '/en/mattress/essential/purchase/' || window.location.pathname === '/fr/mattress/essential/purchase/'
  || window.location.pathname === '/en/mattress/classic/purchase/' || window.location.pathname === '/fr/mattress/classic/purchase/'
      ) {
    ReactDOM.render(<App />, document.getElementById('dummyReact'));
  }
}else {

  // console.log(`checkout page not rendering properly`)
  ReactDOM.render(<App />, document.getElementById('dummyReact'));


    ReactDOM.render(
      <Basketmenuitems ref={ (basketmenuitems) => { window.basketmenuitems = basketmenuitems }} />,
      document.getElementById('basket-items')
    );

  ReactDOM.render(<Minibasket ref={ (Cartbasket) => { window.Cartbasket = Cartbasket }} />, document.getElementById('cocoon-basket'));

  // ReactDOM.render(<Mycart/>, document.getElementById('cocoon-basket'));
  // ReactDOM.render(<Cart/>, document.getElementById('cocoon-basket'));
  // ReactDOM.render(<Cart/>, document.getElementById('basket-items'));
}
